var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps",class:_vm.customClass},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step"},[_c('div',{staticClass:"anchor"}),(index !== 0)?_c('div',{staticClass:"line"}):_vm._e(),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(step)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }